import React, { Fragment } from 'react';
import HeaderCell from './header-cell';
import styles from './region-entity-table.module.scss';

export const EntityTableHeader = ({ entity, comparing }) => {
  if (
    entity.name.includes('Urban Utilities') ||
    entity.name.includes('Unitywater') ||
    entity.name.includes('MIWB')
  ) {
    return null;
  }
  return (
    <Fragment>
      <tr>
        <td className={styles.tableHeaderText}>
          {comparing ? entity.name : 'Summary'}
        </td>
        <td style={{ textAlign: 'right' }}>
          <HeaderCell label={'capacity (ML)'} value={entity.capacity} />
        </td>
        <td style={{ textAlign: 'right' }}>
          <HeaderCell
            label={'storage level (30 JUNE 2021)'}
            value={[entity.storageLevelMin, entity.storageLevelMax]}
          />
        </td>
      </tr>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/region-entity-table/entity-table-header.js